import React from "react"
import { ChangePasswordResult } from "../service"
import { Button } from "@walmart-web/livingdesign-components"
import lockCircle from "assets/images/LockLocked_Circle_Blue.svg"
import { useIntl } from "react-intl"
import "./index.scss"

interface ChangePasswordErrorProps {
	error: ChangePasswordResult
	resetForm: () => void
}

const ChangePasswordError: React.FC<ChangePasswordErrorProps> = ({
	resetForm,
	error,
}) => {
	const intl = useIntl()

	const titleId =
		error === ChangePasswordResult.IncorrectOldPassword
			? "phronesis.configuration.change-password.errors.incorrect-password.title"
			: "phronesis.configuration.change-password.errors.unsuccessful.title"
	const descriptionId =
		error === ChangePasswordResult.IncorrectOldPassword
			? "phronesis.configuration.change-password.errors.incorrect-password.description"
			: "phronesis.configuration.change-password.errors.unsuccessful.description"

	return (
		<div className="change-password-error-container">
			<img src={lockCircle} aria-hidden alt={""} />
			<div className="change-password-error-title">
				{intl.formatMessage({ id: titleId })}
			</div>
			<div className="change-password-error-content">
				{intl.formatMessage({ id: descriptionId })}
			</div>
			<Button variant="primary" size="large" onClick={resetForm}>
				{intl.formatMessage({
					id: "phronesis.configuration.change-password.errors.retry",
				})}
			</Button>
		</div>
	)
}

export default ChangePasswordError
